export interface IRefreshTokenRequest {
  refreshToken: string;
}
